import React, { Component } from 'react';

import { connect } from "react-redux";

class TrackMuteButton extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    onMuteClicked() {
        this.props.track.mute(!this.props.muted);
        this.setState(this.state);
    }

    render() {
        return (
            <div
              onClick={() => this.onMuteClicked()}
              className={this.props.muted ? "muted track-mute-button" : "track-mute-button"}>
            </div>
        );
    }
}

const mapStateToProps = (state, props) => {
    return {
        muted: state.tracks.trackMutes[props.track.trackNumber]
    };
};


export default connect(mapStateToProps, null)(TrackMuteButton);
